export default "__VITE_ASSET__DEu3sFca__"